import { render, staticRenderFns } from "./ProductionPlace.vue?vue&type=template&id=279147ba&scoped=true"
import script from "./ProductionPlace.vue?vue&type=script&lang=js"
export * from "./ProductionPlace.vue?vue&type=script&lang=js"
import style0 from "./ProductionPlace.vue?vue&type=style&index=0&id=279147ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279147ba",
  null
  
)

export default component.exports